"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BMScrollCommand = void 0;
const Command_1 = require("../Command");
const CommandType_1 = require("../lib/CommandType");
class BMScrollCommand extends Command_1.Command {
    constructor() {
        super(CommandType_1.CommandType.BMScroll);
    }
    static parse(_args) {
        return new BMScrollCommand();
    }
}
exports.BMScrollCommand = BMScrollCommand;
